module.exports = __webpack_public_path__ + "static/media/hn-hai-ba-trung.323d6a6e.svg";